import {connect} from "react-redux"
import React from "react"
import {withRouter} from "react-router-dom"
import Contact from "./contacts"
import {openModal} from "../actions/modal_actions"

const msp = (state) => ({
  currentUser: state.session.currentUser ? state.entities.users[state.session.currentUser.id] : null
})

const mdp = (dispatch) => ({
  openModal: (modal, props) => dispatch(openModal(modal, props))
})

export default withRouter(connect(msp, mdp)(Contact))